'use client';

import { Banknote, Lock, PlusCircle } from 'lucide-react';
import React from 'react';

interface CreditBalanceProps {
  availableCredit: number;
  usedCredit?: number;
  totalCredit?: number;
}

const UserCreditInfo: React.FC<CreditBalanceProps> = ({
  availableCredit,
  usedCredit,
  totalCredit,
}) => {
  return (
    <div className="bg-white shadow-md rounded-2xl p-6 w-full max-w-md mx-auto mt-6">
      <h2 className="text-xl font-semibold mb-4 text-gray-800">Saldo em Crédito</h2>

      <div className="text-gray-700 space-y-2">
        <div className="flex items-center gap-2">
          <Banknote size={18} className="text-blue-600" />
          <div>
              <p className="font-medium">Total disponível:</p>
              <p className="text-blue-600 font-semibold text-lg">
            R$ {availableCredit.toFixed(2).replace('.', ',')}</p>
          </div>
        </div>

        {usedCredit !== undefined && (
          <div className="flex items-center gap-2 border-t pt-3">
            <Lock size={18} className="text-yellow-600" />
            <div>
              <p className="font-medium">Em uso em reservas:</p>
              <p className="text-yellow-600 font-semibold text-lg">
                R$ {usedCredit.toFixed(2).replace('.', ',')}
              </p>
            </div>
          </div>
        )}

        {totalCredit !== undefined && (
          <div className="pt-3 border-t">
            <div className="flex items-center gap-2">
              <PlusCircle size={16} className="text-gray-500" />
              <p className="text-sm text-gray-500">Crédito total gerado:</p>
            </div>
            <p className="text-gray-800 text-sm ml-6">
              R$ {totalCredit.toFixed(2).replace('.', ',')}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserCreditInfo;
